module.exports = __webpack_public_path__ + "static/Bubble-Gum-(Schlumpf,-Engelblau)-f5a9bcd6fecc13badc486b3864f48b53.png";